import React from 'react';
import { Select } from '@rio-cloud/rio-uikit';

type Option = {
    value: string | number;
    label: string;
};

type CustomInputSelectProps = {
    value?: string | number;
    options: Option[];
    onChange?: (newValue: string | number) => void;
    disabled?: boolean;
    placeholder?: string;
    className?: string;
    selectRef?: React.RefObject<HTMLSelectElement>;
};

const CustomInputSelect: React.FC<CustomInputSelectProps> = ({
    value = '',
    options,
    onChange,
    disabled = false,
    placeholder = 'Selecione uma opção',
    className = '',
    selectRef,
}) => {


    const handleChange = (value: string) => {
        if (onChange) {
            onChange(value);
        }
    };

    return (
        <div className='width-100pct'>
            <Select
                id='select'
                placeholder={placeholder}
                disabled={disabled}
                options={options.map((option) => {
                    return {
                        id: option.value?.toString(),
                        label: option.label,
                    }
                })}
                onChange={(s) => {
                    if (s) {
                        handleChange(s?.id)
                    }
                }}
                value={[value?.toString() ?? '']}
                className={className}
                btnClassName='rounded-small'
            />
        </div>
    );
};


export default CustomInputSelect;
